let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7gM03")).then(() => parcelRequire('9mEOd'));